<template>
  <div class="shenyunjie-chart-wind-compass" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartWindCompass",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Array,
      default: function () {
        return [];
      }
    },
    unit: {
      type: String,
      default: ""
    },
    grade: {
      type: Boolean,
      default: false
    },
    alarm: {
      type: Boolean,
      default: true
    },
    originNorth: {
      type: Number,
      default: 0
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeWindCompass);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeWindCompass() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        let value = (self.value[1] - self.originNorth) % 360;
        if (value < 0) {
          value = value + 360;
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.title,
            left: "center",
            top: "28%"
          },
          series: [{
            type: "gauge",
            startAngle: 90,
            endAngle: -270,
            min: 0,
            max: 360,
            data: [{
              value: [value],
              name: "风速"
            }],
            splitNumber: 8,
            radius: "80%",
            center: ["50%", "50%"],
            axisLine: {
              lineStyle: {
                width: 3
              }
            },
            splitLine: {
              distance: 0,
              length: 16,
              lineStyle: {
                width: 2
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              distance: -42,
              fontSize: 14,
              formatter: function (value) {
                if (value == 360) {
                  return "";
                }
                return `${value}°`;
              }
            },
            pointer: {
              length: "80%",
              itemStyle: {
                color: "#18BF12"
              }
            },
            detail: {
              valueAnimation: true,
              fontSize: 24,
              formatter: function (value) {
                if (self.grade) {
                  return self.getGrade(self.value[0]);
                }
                return `${self.value[0]}${self.unit}`;
              }
            }
          }, {
            type: "gauge",
            startAngle: 90,
            endAngle: -270,
            min: 0,
            max: 360,
            splitNumber: 16,
            radius: "80%",
            center: ["50%", "50%"],
            axisLine: {
              show: false
            },
            splitLine: {
              distance: -6,
              length: 10,
              lineStyle: {
                width: 1
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              distance: 18,
              fontSize: 12,
              formatter: function (value) {
                if (value == 360) {
                  return "";
                }
                return [
                  "N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
                  "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"
                ][parseInt(value / 22.5)];
              }
            },
            pointer: {
              show: false
            },
            anchor: {
              show: false
            },
            title: {
              show: false
            }
          }]
        };
        let opt = merge(self.defaultOption, parameter);
        if (self.alarm) {
          let alarm = self.getAlarm(self.value[0]);
          opt.title.subtext = alarm[0];
          opt.title.subtextStyle = {
            color: alarm[1],
            fontSize: 14
          };
          if (alarm[1]) {
            opt.series[0].pointer.itemStyle.color = alarm[1];
          }
        }
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    },
    getAlarm(v) {
      let alarm = "";
      let color = "";
      if (v > 37) {
        alarm = "红色预警";
        color = "#CD3338";
      } else if (v > 32.7) {
        alarm = "橙色预警";
        color = "#FC9706";
      } else if (v > 24.5) {
        alarm = "黄色预警";
        color = "#FEFE08";
      } else if (v > 17.2) {
        alarm = "蓝色预警";
        color = "#2E67F4";
      } else {
        return "";
      }
      return [alarm, color];
    },
    getGrade(v) {
      let grade = "";
      if (v < 0.3) {
        grade = "0级(无风)";
      } else if (v < 1.6) {
        grade = "1级(软风)";
      } else if (v < 3.4) {
        grade = "2级(轻风)";
      } else if (v < 5.5) {
        grade = "3级(微风)";
      } else if (v < 8.0) {
        grade = "4级(和风)";
      } else if (v < 10.8) {
        grade = "5级(劲风)";
      } else if (v < 13.9) {
        grade = "6级(强风)";
      } else if (v < 17.2) {
        grade = "7级(疾风)";
      } else if (v < 20.8) {
        grade = "8级(大风)";
      } else if (v < 24.5) {
        grade = "9级(烈风)";
      } else if (v < 28.5) {
        grade = "10级(狂风)";
      } else if (v < 32.7) {
        grade = "11级(暴风)";
      } else {
        grade = "12级(飓风)及以上";
      }
      return grade;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindCompass);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value: {
      deep: true,
      handler(xData) {
        this.init();
      }
    },
    unit() {
      this.init();
    },
    grade() {
      this.init();
    },
    alarm() {
      this.init();
    },
    originNorth() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-wind-compass {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/windCompass.vue